import * as React from "react";
const SvgHamburgerIcon = (props) => /* @__PURE__ */ React.createElement("svg", { focusable: "false", "aria-hidden": "true", viewBox: "0 0 24 24", width: "1em", height: "1em", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M3 18h18v-2H3v2zm0-5h18v-2H3v2zm0-7v2h18V6H3z" }));
export default SvgHamburgerIcon;
